// Dashboard texts, Uzbek (Latin). Orthography: ʻ (U+02BB) in oʻ / gʻ and ʼ (U+02BC) for the tutuq
// belgisi, as in the Telegram catalog. Wording needs native-speaker review before production
// (docs/DASHBOARD_SPECIFICATION.md §8). All user-facing dashboard text lives here, never in components.

export const dashboardUzLatn = {
  app: {
    name: 'Sotuv paneli',
    skipToContent: 'Asosiy mazmunga oʻtish',
    pageTitle: (page: string) => `${page} · Sotuv paneli`,
  },
  demo: {
    banner: 'DEMO MAʼLUMOTLAR — haqiqiy emas',
    notInSnapshotTitle: 'Demo versiyada mavjud emas',
    notInSnapshot:
      'Bu demo versiyada faqat tayyor davrlar (Bugun, Kecha, Bu hafta, Oxirgi 7 kun, Bu oy, Oxirgi 30 kun, Oʻtgan oy, Bu chorak) filtrlarsiz koʻrsatiladi.',
  },
  nav: {
    label: 'Asosiy navigatsiya',
    overview: 'Umumiy koʻrinish',
    funnel: 'Voronka',
    clients: 'Mijozlar',
    team: 'Jamoa',
    marketing: 'Marketing',
    status: 'Holat',
    bottomLabel: 'Sahifalar',
    more: 'Yana',
    short: {
      overview: 'Asosiy',
      funnel: 'Voronka',
      clients: 'Mijozlar',
      team: 'Jamoa',
      marketing: 'Marketing',
      status: 'Holat',
    },
    openMenu: 'Menyuni ochish',
    closeMenu: 'Menyuni yopish',
    back: 'Orqaga qaytish',
    hideSidebar: 'Yon panelni yopish',
    showSidebar: 'Yon panelni ochish',
    account: 'Hisob',
    themeToLight: 'Kunduzgi rejimga oʻtish',
    themeToDark: 'Tungi rejimga oʻtish',
    signOut: 'Chiqish',
    signedInAs: (name: string) => `${name} sifatida kirgansiz`,
  },
  login: {
    title: 'Tizimga kirish',
    intro: 'Hisobingiz bilan kiring.',
    email: 'Login',
    password: 'Parol',
    submit: 'Kirish',
    submitting: 'Kirilmoqda…',
    invalid: 'Elektron pochta yoki parol notoʻgʻri.',
    locked: (minutes: number) =>
      `Juda koʻp muvaffaqiyatsiz urinish. ${minutes} daqiqadan keyin qayta urinib koʻring.`,
    rateLimited: 'Juda koʻp soʻrov yuborildi. Birozdan keyin qayta urinib koʻring.',
    failed: 'Kirib boʻlmadi. Keyinroq qayta urinib koʻring.',
    expired: 'Seans tugadi. Qayta kiring.',
    otpLabel: 'Autentifikator kodi',
    otpHint: 'Telefondagi autentifikator ilovasidagi 6 xonali kodni kiriting.',
    otpInvalid: 'Kod yoki parol notoʻgʻri.',
  },
  security: {
    title: 'Xavfsizlik',
    navLabel: 'Xavfsizlik',
    intro: 'Hisobingiz xavfsizligi: parol va ikki bosqichli tasdiqlash.',
    twoFactorIntro: 'Hisobingizni qoʻshimcha himoyalash uchun ikki bosqichli tasdiqlashni yoqing.',
    twoFactorTitle: 'Ikki bosqichli tasdiqlash',
    enabled: 'Ikki bosqichli tasdiqlash yoqilgan.',
    enabledHint:
      'Kirishda parol bilan birga autentifikator kodi soʻraladi. Telefon yoʻqolsa, administratorga murojaat qiling.',
    disabled: 'Ikki bosqichli tasdiqlash yoqilmagan.',
    start: 'Yoqish',
    starting: 'Tayyorlanmoqda…',
    step1:
      '1. Autentifikator ilovasida (Google Authenticator, Authy va boshqalar) yangi hisob qoʻshing va quyidagi kalitni qoʻlda kiriting:',
    secretLabel: 'Kalit',
    step2: '2. Ilovada koʻringan 6 xonali kodni kiriting:',
    codeLabel: 'Kod',
    confirm: 'Tasdiqlash',
    confirming: 'Tekshirilmoqda…',
    wrongCode: 'Kod notoʻgʻri. Qayta urinib koʻring.',
    unavailable: 'Bu serverda ikki bosqichli tasdiqlash sozlanmagan.',
    failed: 'Amalni bajarib boʻlmadi. Keyinroq qayta urinib koʻring.',
  },
  common: {
    showPassword: 'Parolni koʻrsatish',
    hidePassword: 'Parolni yashirish',
    loading: 'Yuklanmoqda…',
    retry: 'Qayta urinish',
    reload: 'Sahifani yangilash',
    close: 'Yopish',
    apply: 'Qoʻllash',
    reset: 'Tozalash',
    all: 'Barchasi',
    total: 'Jami',
    noData: 'Maʼlumot yoʻq',
    dash: '—',
    notAvailable: 'Mavjud emas',
    unknown: 'Nomaʼlum',
    unassigned: 'Biriktirilmagan',
    notSpecified: 'Koʻrsatilmagan',
    inactive: 'faol emas',
    optional: 'ixtiyoriy',
    showTable: 'Jadvalni koʻrsatish',
    info: 'Izoh',
    sortBy: (column: string) => `Saralash: ${column}`,
    dataTable: 'Maʼlumotlar jadvali',
    dismiss: 'Yopish',
    chartTable: (title: string) => `${title}: maʼlumotlar jadvali`,
    offline: 'Internet aloqasi yoʻq. Aloqa tiklanganda maʼlumotlar yangilanadi.',
  },
  errors: {
    title: 'Maʼlumotni yuklab boʻlmadi',
    detail: 'Soʻrovni bajarishda xatolik yuz berdi. Qayta urinib koʻring.',
    requestId: (id: string) => `Soʻrov raqami: ${id}`,
    forbiddenTitle: 'Ruxsat yoʻq',
    forbiddenDetail:
      'Bu sahifani koʻrish uchun sizda yetarli huquq yoʻq. Maʼmurga murojaat qiling.',
    notFoundTitle: 'Sahifa topilmadi',
    notFoundDetail: 'Bunday sahifa mavjud emas yoki koʻchirilgan.',
    backHome: 'Bosh sahifaga qaytish',
    unknownSalesperson: 'Bunday menejer topilmadi.',
  },
  period: {
    label: 'Davr',
    from: 'Boshlanish sanasi',
    to: 'Tugash sanasi',
    presets: {
      today: 'Bugun',
      yesterday: 'Kecha',
      thisWeek: 'Bu hafta',
      last7: 'Oxirgi 7 kun',
      thisMonth: 'Bu oy',
      last30: 'Oxirgi 30 kun',
      lastMonth: 'Oʻtgan oy',
      thisQuarter: 'Bu chorak',
      custom: 'Boshqa davr',
    },
    invalid: 'Tugash sanasi boshlanish sanasidan oldin boʻlmasligi kerak.',
    tooLong: 'Davr 400 kundan oshmasligi kerak.',
    range: (from: string, to: string) => (from === to ? from : `${from} – ${to}`),
  },
  compare: {
    label: 'Taqqoslash',
    previous_period: 'Oldingi davr bilan',
    previous_week: 'Oʻtgan hafta bilan',
    previous_year: 'Oʻtgan yil bilan',
    none: 'Taqqoslamasdan',
    with: (range: string) => `Taqqoslash davri: ${range}`,
    change: 'oʻzgarish',
    pp: 'f.p.',
    up: 'oshdi',
    down: 'kamaydi',
    same: 'oʻzgarmadi',
    noPrevious: 'Oldingi davr maʼlumoti yoʻq',
    previous: (value: string) => `oldingi: ${value}`,
  },
  filters: {
    title: 'Filtrlar',
    open: 'Filtrlarni ochish',
    salesperson: 'Menejer',
    source: 'Manba',
    clearAll: 'Barcha filtrlarni tozalash',
    active: 'Faol filtrlar',
    remove: (name: string) => `${name} filtrini olib tashlash`,
    none: 'Tanlanmagan',
    selected: (count: number) => `${count} ta tanlangan`,
    scopeNote: 'Siz faqat oʻz maʼlumotlaringizni koʻryapsiz.',
  },
  freshness: {
    asOf: (time: string) => `Maʼlumotlar ${time} holatiga`,
    neverSynced: 'Sinxronizatsiya hali boʻlmagan',
    fresh: 'yangi',
    delayed: 'kechikkan',
    stale: 'eskirgan',
    demoNote: 'Demo maʼlumotlar talab boʻyicha yaratiladi',
    staleBanner: 'Maʼlumotlar eskirgan boʻlishi mumkin',
    label: 'Maʼlumotlar yangiligi',
  },
  badge: { activity: 'Faoliyat', cohort: 'Kohorta', state: 'Holat' },
  badgeHelp: {
    activity: 'Tanlangan davrda sodir boʻlgan hodisalar soni.',
    cohort: 'Davrda yaratilgan lidlar guruhi va ularning bugungi natijasi.',
    state: 'Hozirgi holat (davrga bogʻliq emas).',
  },
  units: {
    leads: 'lid',
    deals: 'bitim',
    containers: 'dona',
    containers_per_deal: 'dona/bitim',
    visits: 'tashrif',
    tasks: 'vazifa',
    ratio: '',
    minutes: 'daq.',
    hours: 'soat',
    seconds: 'son.',
    calls: 'ta',
    money: '',
  },
  kpi: {
    leadsNew: {
      name: 'Yangi lidlar',
      definition:
        'Davr ichida kelib tushgan yangi lidlar (yaratilgan sana boʻyicha). Hisobga olinmaydi: spam, dublikat va boshqa loyiha lidlari.',
    },
    leadsContacted: {
      name: 'Aloqa oʻrnatilgan lidlar',
      definition:
        'Davr ichida birinchi marta aloqa oʻrnatilgan lidlar. Har bir lid faqat bir marta hisoblanadi.',
    },
    leadsQualified: {
      name: 'Sifatli lidlar',
      definition:
        'Davr ichida sifatli deb belgilangan lidlar. Sifat mezoni savdo boshqaruvi tomonidan belgilanadi.',
    },
    visitsPlanned: {
      name: 'Rejalashtirilgan tashriflar',
      definition:
        'Davr ichida “tashrif rejalashtirildi” bosqichiga oʻtgan lidlar soni (tashrif yozuvlari emas, lidlar).',
    },
    visitsCompleted: {
      name: 'Amalga oshgan tashriflar',
      definition: 'Davr ichida “tashrif amalga oshdi” bosqichiga oʻtgan lidlar soni.',
      unavailable:
        'CRMʼda tashrif amalga oshganini bildiruvchi alohida bosqich yoʻq, shuning uchun bu koʻrsatkichni hisoblab boʻlmaydi.',
    },
    dealsWon: {
      name: 'Muvaffaqiyatli bitimlar',
      definition: 'Davr ichida yutilgan (sotilgan) lidlar soni — yutilgan sana boʻyicha.',
    },
    containersSold: {
      name: 'Sotilgan konteynerlar',
      definition:
        'Davrdagi muvaffaqiyatli bitimlardagi konteynerlar soni. Bitimlar bilan aralashtirilmaydi.',
    },
    containersPerDeal: {
      name: 'Bitimga konteyner (oʻrtacha)',
      definition:
        'Sotilgan konteynerlar / konteyner kiritilgan bitimlar soni. Konteyner kiritilmagan bitimlar hisobga olinmaydi.',
    },
    overallConversion: {
      name: 'Umumiy konversiya',
      definition:
        'Oxirgi 30 kunda yaratilgan lidlarning qancha qismi bitimga aylangan (kohorta). Bir kunlik faoliyat nisbati emas.',
      basis: (from: string, to: string, size: string) => `Kohorta: ${from} – ${to}, ${size} ta lid`,
    },
  },
  immature: {
    title: 'Kohorta hali yakunlanmagan',
    detail: (age: number, window: number) =>
      `Kohorta yoshi ${age} kun (yakunlanish muddati ${window} kun). Yaqinda yaratilgan lidlar hali natijaga yetmagan, shuning uchun foizlar keyinroq oʻsishi mumkin.`,
  },
  home: {
    sections: {
      sales: 'Sotuv',
      calls: 'Qoʻngʻiroqlar',
      ads: 'Reklama',
      more: 'Qoʻshimcha maʼlumotlar',
    },
    sectionHints: {
      sales: 'Tanlangan davrdagi lidlar va sotuvlar',
      calls: 'Mijozlar bilan barcha kiruvchi va chiquvchi qoʻngʻiroqlar',
      ads: 'Facebook / Instagram va Google reklamasi',
    },
    kpi: {
      conversionNote: (from: string, to: string) => `${from} – ${to} lidlari boʻyicha`,
      callsTotal: {
        name: 'Qoʻngʻiroqlar',
        definition:
          'Davrdagi barcha qoʻngʻiroqlar: kiruvchi va chiquvchi, javob berilgan va javobsiz. Faqat shu loyiha lidlariga tegishli qoʻngʻiroqlar hisoblanadi.',
        split: (inbound: string, outbound: string) => `kiruvchi ${inbound} · chiquvchi ${outbound}`,
      },
      answerRate: {
        name: 'Javob berilgan',
        definition:
          'Kiruvchi qoʻngʻiroqlarning necha foiziga xodim javob bergan: javob berilgan ÷ barcha kiruvchi qoʻngʻiroqlar.',
        missed: (count: string) => `${count} ta javobsiz`,
      },
      avgWait: {
        name: 'Javobni kutish',
        definition:
          'Mijoz xodim javob berguncha oʻrtacha necha soniya kutgan (javob berilgan kiruvchi qoʻngʻiroqlar).',
        unavailable: 'Telefoniya kutish vaqtini bermaydi.',
      },
      avgTalk: {
        name: 'Suhbat davomiyligi',
        definition:
          'Javob berilgan qoʻngʻiroqlarning oʻrtacha davomiyligi (kiruvchi va chiquvchi).',
      },
      missedNotReturned: {
        name: 'Qayta qoʻngʻiroq qilinmagan',
        definition: (minutes: number) =>
          `Javobsiz qolgan kiruvchi qoʻngʻiroqlar, ularga ${minutes} daqiqa ichida qayta qoʻngʻiroq qilinmagan va mijoz bilan gaplashilmagan. Bu yoʻqotilishi mumkin boʻlgan mijozlar.`,
        pending: (count: string) => `yana ${count} tasi hali kutilmoqda`,
      },
      spend: {
        name: 'Reklama xarajati',
        definition:
          'Davr kunlarida reklama tizimlarida sarflangan pul (Facebook / Instagram, Google).',
      },
      ctr: {
        name: 'CTR',
        definition: 'Reklamani koʻrganlarning necha foizi bosgan: kliklar ÷ koʻrishlar.',
      },
      cpl: {
        name: 'Lid narxi (CPL)',
        definition:
          'Bitta lid necha pulga tushgan: reklama xarajati ÷ reklamadan kelgan lidlar. Lid boʻlmasa — “—”.',
      },
      cac: {
        name: 'Mijoz narxi (CAC)',
        definition:
          'Bitta sotuv necha pulga tushgan: reklama xarajati ÷ shu davr reklama lidlaridan boʻlgan sotuvlar.',
      },
      roas: {
        name: 'ROAS',
        definition:
          'Reklamaga sarflangan har 1 dollar qancha daromad keltirgan: daromad ÷ xarajat. 1x dan kam — reklama oʻzini qoplamagan. Hech qachon manfiy boʻlmaydi.',
        lowerBound: 'Baʼzi sotuvlarda summa yoʻq — haqiqiy ROAS bundan yuqori.',
      },
    },
    funnel: {
      title: 'Voronka',
      subtitle: 'Shu davrda kelgan lidlar bilan nima boʻldi',
      lid: 'Lid',
      contacted: 'Aloqaga chiqildi',
      won: 'Xarid qildi',
      lost: 'Xarid qilmaydi',
      open: 'Jarayonda',
      notContacted: (count: string, share: string) => `aloqaga chiqilmagan: ${count} (${share})`,
      ofContacted: 'aloqaga chiqilganlardan',
      conversion: (share: string) => `Liddan xaridgacha: ${share}`,
      help: 'Davrda yaratilgan lidlar bugungi holati bilan. “Xarid qilmaydi” — “Xarid qildi”dan oldingi bosqich emas, balki alohida natija. Uch natija yigʻindisi aloqaga chiqilganlar soniga teng.',
      empty: 'Bu davrda lid yoʻq.',
    },
    hours: {
      title: 'Qoʻngʻiroqlar soatlar boʻyicha',
      answered: 'Javob berilgan',
      notAnswered: 'Javobsiz',
      hour: 'Soat',
      workHours: 'ish vaqti',
      range: (hour: number) => `${hour}:00–${hour + 1}:00`,
      answerRate: (share: string) => `kiruvchilarga javob: ${share}`,
      empty: 'Bu davrda qoʻngʻiroqlar yoʻq.',
    },
    heatmap: {
      title: 'Qoʻngʻiroqlar: hafta kuni va soat',
      subtitle: 'Rang qancha toʻq boʻlsa, shu vaqtda shuncha koʻp',
      metric: 'Koʻrsatkich',
      metrics: { calls: 'Qoʻngʻiroqlar', answerRate: 'Javob %', wait: 'Kutish' },
      weekdays: ['Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh', 'Ya'],
      weekdaysLong: [
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba',
        'Yakshanba',
      ],
      perDay: (value: string) => `kuniga oʻrtacha ${value} ta`,
      busiest: (list: string) => `Eng band vaqt: ${list}`,
      low: 'kam',
      high: 'koʻp',
      tooFew: 'kam qoʻngʻiroq — hisoblanmaydi',
      waitSeconds: (value: string) => `oʻrtacha kutish ${value}`,
      answered: (share: string) => `javob ${share}`,
    },
    sources: {
      title: 'Lid manbalari',
      unknownShare: (share: string) =>
        `${share} lidning manbasi aniqlanmagan: CRMʼda manba toʻliq belgilanmayapti. Manba qoidalari sozlangach aniqlashadi.`,
      more: 'Batafsil — Marketing',
      empty: 'Bu davrda lid yoʻq.',
    },
    ads: {
      title: 'Reklama samaradorligi',
      level: 'Daraja',
      levels: { campaign: 'Kampaniya', ad_set: 'Auditoriya', ad: 'Eʼlon' },
      columns: {
        name: 'Nomi',
        spend: 'Xarajat',
        impressions: 'Koʻrishlar',
        clicks: 'Kliklar',
        ctr: 'CTR',
        leads: 'Lidlar',
        cpl: 'CPL',
        sales: 'Sotuvlar',
        cac: 'CAC',
        revenue: 'Daromad',
        roas: 'ROAS',
      },
      total: 'Jami',
      loss: 'zarar',
      unattributed: (leads: string, sales: string) =>
        `Reklamaga bogʻlanmagan lidlar: ${leads} (sotuvlar: ${sales}). Ular jadvalda yoʻq.`,
      coverage: (share: string) =>
        `Sotuvlarning ${share} qismida summa bor; daromad va ROAS shu qism boʻyicha.`,
      unknownLeads:
        'Bu kampaniya lidlari faqat kampaniya darajasida bogʻlangan — eʼlon/auditoriya boʻyicha ajratib boʻlmaydi.',
      filtersIgnored:
        'Reklama xarajatini menejer yoki manba boʻyicha ajratib boʻlmaydi, shuning uchun bu boʻlim filtrlarsiz.',
      excluded: (list: string) => `Boshqa valyutadagi hisoblar hisobga olinmadi: ${list}.`,
      cohortNote:
        'Lidlar va sotuvlar — shu davr lidlari; yangi lidlar hali sotib olishga ulgurmagan boʻlishi mumkin.',
      chartTitle: 'CPL va CAC auditoriyalar boʻyicha',
      chartNote: 'Har bir koʻrsatkich oʻz shkalasida. Eng koʻp xarajat qilingan 10 tasi.',
      empty: 'Bu davrda reklama xarajati yoʻq.',
    },
  },
  overview: {
    title: 'Umumiy koʻrinish',
    leads: 'Lidlar',
    outcomes: 'Natijalar',
    conversion: 'Konversiya',
    trend: 'Vaqt boʻyicha oʻzgarish',
    trendTooShortTitle: 'Oʻzgarishni koʻrish uchun davr juda qisqa',
    trendTooShort:
      'Bir kunlik davrda solishtiradigan narsa yoʻq. Kamida 2 kunlik davrni tanlang (masalan, «Oxirgi 7 kun»).',
    trendMetric: 'Koʻrsatkich',
    containersByType: 'Konteynerlar turlari boʻyicha',
    containersEmpty: 'Tanlangan davrda sotilgan konteynerlar yoʻq.',
    alerts: 'Diqqat talab qiladi',
    noAlerts: 'Hozircha diqqat talab qiladigan holatlar yoʻq.',
    autoType: 'avtomatik tur — maʼmur tekshirishi kerak',
  },
  trendMetrics: {
    leadsNew: 'Yangi lidlar',
    leadsContacted: 'Aloqa oʻrnatilgan',
    leadsQualified: 'Sifatli lidlar',
    visitsPlanned: 'Rejalashtirilgan tashriflar',
    visitsCompleted: 'Amalga oshgan tashriflar',
    dealsWon: 'Bitimlar',
    containersSold: 'Konteynerlar',
    dealsLost: 'Rad etilgan bitimlar',
  },
  granularity: { day: 'kunlar boʻyicha', week: 'haftalar boʻyicha', month: 'oylar boʻyicha' },
  alerts: {
    FOLLOWUP_OVERDUE: 'Muddati oʻtgan vazifalar',
    LEADS_UNCONTACTED_AGING: 'Uzoq vaqt javobsiz lidlar',
    DATA_STALE: 'Maʼlumotlar eskirgan',
    DQ_LEAD_WITHOUT_SOURCE: 'Manbasi koʻrsatilmagan lidlar',
    DQ_WON_WITHOUT_ITEMS: 'Konteyneri kiritilmagan bitimlar',
    DQ_LOST_WITHOUT_REASON: 'Sababi koʻrsatilmagan rad etishlar',
    DQ_UNMAPPED_STAGE: 'Sozlanmagan bosqichdagi lidlar',
    severity: { info: 'maʼlumot', warning: 'ogohlantirish', critical: 'jiddiy' },
    open: 'Batafsil',
  },
  funnel: {
    title: 'Sotuv voronkasi',
    mode: 'Rejim',
    cohort: 'Kohorta',
    activity: 'Faoliyat',
    cohortHelp: 'Tanlangan davrda yaratilgan lidlar va ularning bugungi natijasi.',
    activityHelp:
      'Tanlangan davrda sodir boʻlgan hodisalar soni, ular qachon yaratilganidan qatʼi nazar.',
    activityNotice: 'Bu kohorta konversiyasi emas',
    activityNoticeDetail:
      'Faoliyat rejimida foizlar koʻrsatilmaydi: bir kunlik hodisalarni bir-biriga boʻlish konversiya hisoblanmaydi.',
    steps: {
      NEW: 'Yangi',
      CONTACTED: 'Aloqa oʻrnatildi',
      QUALIFIED: 'Sifatli',
      VISIT_SCHEDULED: 'Tashrif rejalashtirildi',
      VISIT_COMPLETED: 'Tashrif amalga oshdi',
      WON: 'Bitim',
    },
    optionalStep: 'ixtiyoriy bosqich',
    impliedNote: (count: number) => `${count} tasi keyingi bosqich orqali taxmin qilingan`,
    columns: {
      step: 'Bosqich',
      count: 'Soni',
      ofCohort: 'Kohortadan',
      fromPrevious: 'Oldingisidan',
      median: 'Median vaqt',
      p90: '90-persentil',
    },
    conversions: 'Bosqichlar oʻrtasidagi oʻtish',
    wonPaths: 'Bitimlar qaysi yoʻl bilan yutilgan',
    wonPathsHelp:
      'Uch guruh bir-biriga kirmaydi va umumiy bitimlar soniga teng. Rejalashtirilgan tashrif amalga oshgan tashrif emas.',
    afterCompletedVisit: 'Amalga oshgan tashrifdan keyin',
    afterPlannedVisitOnly: 'Faqat rejalashtirilgan tashrifdan keyin',
    withoutVisit: 'Tashrifsiz',
    lost: 'Rad etilgan',
    open: 'Jarayonda',
    visitsUnavailable:
      'Tashrif amalga oshganini bildiruvchi bosqich CRMʼda yoʻq. Rejalashtirilgan va amalga oshgan tashriflar aralashtirilmaydi.',
    losses: 'Rad etish sabablari',
    lossesBasis: 'Hisoblash asosi',
    basisLostAt: 'Rad etilgan sana boʻyicha',
    basisCohort: 'Kohorta boʻyicha',
    furthest: 'Rad etishdan oldin yetib borgan eng uzoq bosqich',
    timeToMilestone: 'Bosqichgacha oʻtgan vaqt',
    emptyCohort: 'Tanlangan davrda lidlar yaratilmagan.',
    hours: (value: string) => `${value} soat`,
  },
  clients: {
    title: 'Mijozlar',
    caption: 'Mijozlar roʻyxati',
    privacyNote:
      'Mijozlarning ismlari va xarid maqsadi shaxsiy maʼlumot hisoblanadi: faqat ruxsati bor foydalanuvchilar koʻradi.',
    searchLabel: 'Mijoz ismi boʻyicha qidirish',
    searchPlaceholder: 'Ism…',
    empty: 'Tanlangan davrda mijozlar topilmadi.',
    noName: 'Ism koʻrsatilmagan',
    columns: {
      date: 'Sana',
      name: 'Mijoz',
      source: 'Manba',
      region: 'Viloyat',
      purpose: 'Xarid maqsadi',
      containerSize: 'Konteyner oʻlchami',
      timeframe: 'Xarid muddati',
      status: 'Holat',
      manager: 'Menejer',
    },
    outcome: { open: 'Jarayonda', won: 'Xarid qildi', lost: 'Xarid qilmaydi' },
    range: (from: number, to: number, total: number) => `${from}–${to} / ${total}`,
    previous: 'Oldingi',
    next: 'Keyingi',
    pagination: 'Sahifalar',
  },
  team: {
    title: 'Sotuv jamoasi',
    leaderboard: 'Menejerlar boʻyicha natijalar',
    neutralNote: 'Jadval tartibi: avval konteynerlar, keyin bitimlar. Bu reyting emas.',
    calls: {
      title: 'Menejerlar boʻyicha qoʻngʻiroqlar',
      note: 'Faqat lidga bogʻlangan qoʻngʻiroqlar hisobga olinadi. «Mijozlar» — kamida bitta javob berilgan qoʻngʻirogʻi boʻlgan noyob mijozlar.',
      calls: 'Qoʻngʻiroqlar',
      answered: 'Javob berilgan',
      clients: 'Gaplashilgan mijozlar',
      talkTime: 'Umumiy suhbat vaqti',
      avgTalk: 'Bir qoʻngʻiroqqa oʻrtacha',
      totalsNote:
        'Jami qatorda mijoz bir marta sanaladi, hatto bir nechta menejer u bilan gaplashgan boʻlsa ham.',
    },
    highlights: {
      title: 'Suhbatlar: eng qisqa, eng uzun, eng koʻp',
      note: 'Davomiyligi maʼlum boʻlgan javob berilgan qoʻngʻiroqlar. Yozuvni tinglash uchun qoʻngʻiroqni CRMda oching.',
      shortest: 'Suhbat eng kam vaqt davom etgan',
      longest: 'Suhbat eng koʻp vaqt davom etgan',
      topClient: 'Eng koʻp marta gaplashilgan',
      teamTitle: 'Butun jamoa',
      callsCount: (count: string) => `${count} ta qoʻngʻiroq`,
      talkTotal: (duration: string) => `jami ${duration}`,
      lastCall: (when: string) => `oxirgisi ${when}`,
      noName: 'Ismi yoʻq mijoz',
      inbound: 'kiruvchi',
      outbound: 'chiquvchi',
      openInCrm: 'CRMda ochish',
      callId: (id: string) => `Qoʻngʻiroq ID: ${id}`,
      answered: 'Javob berilgan',
    },
    columns: {
      name: 'Menejer',
      leadsAssigned: 'Biriktirilgan lidlar',
      leadsContacted: 'Aloqa oʻrnatilgan',
      leadsQualified: 'Sifatli',
      visitsPlanned: 'Tashrif (reja)',
      visitsCompleted: 'Tashrif (amalga)',
      dealsWon: 'Bitimlar',
      containersSold: 'Konteynerlar',
      cohortConversion: 'Kohorta konversiyasi',
      firstResponse: 'Birinchi javob (median)',
      followUpOnTime: 'Vazifalar oʻz vaqtida',
      followUpsOverdue: 'Muddati oʻtgan',
    },
    attribution: {
      initial_owner: 'Lid yaratilgan paytdagi egasiga hisoblanadi.',
      owner_at_milestone: 'Bosqichga oʻtgan paytdagi egasiga hisoblanadi.',
      owner_at_won: 'Bitim yutilgan paytdagi egasiga hisoblanadi.',
      task_owner: 'Vazifa egasiga hisoblanadi.',
    },
    unassigned: 'Biriktirilmagan',
    totals: 'Jami (umumiy koʻrsatkichlarga mos)',
    detail: {
      metrics: 'Koʻrsatkichlar',
      funnel: 'Menejerning kohortasi',
      trend: 'Dinamika',
      overdue: 'Muddati oʻtgan vazifalar (yoshi boʻyicha)',
      reassignments: 'Lidlarning qayta biriktirilishi',
      reassignedIn: 'Menejerga oʻtgan',
      reassignedOut: 'Menejerdan chiqqan',
      ages: { lt1d: '1 kundan kam', d1to3: '1–3 kun', gt3d: '3 kundan koʻp' },
    },
    empty: 'Tanlangan davrda menejerlar boʻyicha maʼlumot yoʻq.',
  },
  marketing: {
    title: 'Marketing samaradorligi',
    sources: 'Manbalar boʻyicha',
    trend: 'Yangi lidlar dinamikasi (manbalar boʻyicha)',
    mix: 'Manbalar ulushi',
    unknownSource: 'Manbasi nomaʼlum',
    columns: {
      source: 'Manba',
      leadsNew: 'Yangi lidlar',
      dealsWon: 'Bitimlar',
      containersSold: 'Konteynerlar',
      cohortSize: 'Kohorta (lidlar)',
      qualifiedRate: 'Sifatli ulushi',
      wonRate: 'Bitimga aylanishi',
    },
    cohortPeriod: (range: string) => `Kohorta davri: ${range}`,
    notAvailable: 'Reklama xarajatlari, koʻrishlar va kliklar CRMʼda mavjud emas.',
    empty: 'Tanlangan davrda yangi lidlar yoʻq.',
  },
  status: {
    title: 'Tizim holati',
    dataSource: 'Maʼlumot manbai',
    datasetKind: 'Maʼlumotlar turi',
    demo: 'demo',
    live: 'haqiqiy',
    freshness: 'Maʼlumotlar yangiligi',
    entity: 'Obyekt',
    lastSuccess: 'Oxirgi muvaffaqiyatli',
    failures: 'Ketma-ket xatolar',
    lastError: 'Oxirgi xato',
    syncRuns: 'Oxirgi sinxronizatsiyalar',
    run: {
      kind: 'Turi',
      status: 'Holati',
      started: 'Boshlangan',
      finished: 'Tugagan',
      error: 'Xato',
    },
    runStatus: { running: 'ishlamoqda', succeeded: 'muvaffaqiyatli', failed: 'xato bilan tugadi' },
    worker: 'Fon xizmati',
    workerUnknown: 'Hozircha kuzatilmaydi',
    quality: 'Maʼlumotlar sifati',
    qualityHelp: 'Maʼlumot kiritishdagi kamchiliklar koʻrsatkichlarni buzishi mumkin.',
    qualityItems: {
      leadsWithoutSource: 'Manbasi koʻrsatilmagan lidlar',
      wonWithoutItems: 'Konteyneri kiritilmagan bitimlar',
      wonWithoutCustomer: 'Mijozi bogʻlanmagan bitimlar',
      lostWithoutReason: 'Sababi koʻrsatilmagan rad etishlar',
      unmappedStage: 'Sozlanmagan bosqichdagi lidlar (hozir)',
      unknownContainerType: 'Turi nomaʼlum konteynerlar',
      autoContainerType: 'Avtomatik yaratilgan turdagi konteynerlar',
    },
    lineItems: (count: number, containers: number) => `${count} qator, ${containers} dona`,
  },
} as const;

type Widen<T> = T extends string
  ? string
  : T extends (...args: infer A) => string
    ? (...args: A) => string
    : T extends readonly string[]
      ? readonly string[]
      : { -readonly [K in keyof T]: Widen<T[K]> };

/** The shape every dashboard locale must provide (strings and string-returning functions). */
export type DashboardCatalog = Widen<typeof dashboardUzLatn>;
